module.exports = __webpack_public_path__ + "img/mentions_white.57bdfd1f.svg";